import React from 'react'
import MyWalletVirtualCardsTable from 'src/components/DataGrid/tables/MyWalletVirtualCardsTable'

const MyWalletVirtualCards: React.FC = () => {
  return <MyWalletVirtualCardsTable />
}

export default MyWalletVirtualCards
